import { render, staticRenderFns } from "./QuoteOfDay.vue?vue&type=template&id=16285f3e&scoped=true&"
import script from "./QuoteOfDay.vue?vue&type=script&lang=js&"
export * from "./QuoteOfDay.vue?vue&type=script&lang=js&"
import style0 from "./QuoteOfDay.vue?vue&type=style&index=0&id=16285f3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16285f3e",
  null
  
)

export default component.exports